import "./App.css";

const socialLinks = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/fitmatchuk/",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3.5" y="3.5" width="17" height="17" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="1" />
      </svg>
    ),
  },
  {
    label: "TikTok",
    href: "https://www.tiktok.com/@fitmatchuk",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M14 4v8.2a3.7 3.7 0 1 1-2.6-3.5V6.1c1.5.1 2.7-.3 3.8-2.1h2.3c.2 2 1.2 3.1 3 3.8v2.5c-1.8-.2-3.2-.8-4.5-1.9v7.2a6.3 6.3 0 1 1-4.6-6.1V4H14z" />
      </svg>
    ),
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61580607825792",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M13.5 21v-7h2.3l.4-2.8h-2.7V9.4c0-.8.2-1.4 1.4-1.4H16V5.5c-.2 0-1-.1-2-.1-2.4 0-4.1 1.4-4.1 4.2v1.6H7.7V14h2.2v7h3.6z" />
      </svg>
    ),
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/fit-match-uk/",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M6.3 8.8a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6zM4.7 20V10.1h3.2V20H4.7zM10.1 20v-9.9h3.1v1.4h.1c.4-.8 1.5-1.6 3-1.6 3.2 0 3.8 2.1 3.8 4.9V20h-3.2v-4.6c0-1.1 0-2.5-1.5-2.5s-1.8 1.2-1.8 2.4V20h-3.5z" />
      </svg>
    ),
  },
  {
    label: "Email Us",
    href: "mailto:contact@fit-match.co.uk",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 6h16a2 2 0 0 1 2 2v.5l-10 6.3L2 8.5V8a2 2 0 0 1 2-2z" />
        <path d="M2 10.8v7.2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-7.2l-9.5 6a1 1 0 0 1-1 0L2 10.8z" />
      </svg>
    ),
  },
  {
    label: "Visit Our Website",
    href: "https://fit-match.co.uk/",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path d="M3.5 12h17M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
      </svg>
    ),
  },
];

function SocialCard() {
  return (
    <main className="social-card-page">
      <section className="social-card-panel">
        <img
          src="/images/logo.png"
          alt="Fit-Match logo"
          className="social-card-logo"
        />
        <h1 className="social-card-title">Fit-Match</h1>
        <p className="social-card-subtitle">
          Connect with us and find your perfect fitness match.
        </p>
        <p className="social-card-handle">@fitmatchuk</p>

        <div className="social-card-links">
          {socialLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="social-card-link"
            >
              <span className="social-card-link-left">
                <span className="social-card-icon">{link.icon}</span>
                <span>{link.label}</span>
              </span>
              <span className="social-card-arrow" aria-hidden="true">
                →
              </span>
            </a>
          ))}
        </div>
      </section>
    </main>
  );
}

export default SocialCard;
